module.exports = __webpack_public_path__ + "static/media/w9.941f5b50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/w9.jpg
// module id = 313
// module chunks = 0